import React from "react";
import defaultSSHorizontalJpg from "../../../assets/img/defaultScreenshotHorizontal.jpg";
import defaultSSVerticalJpg from "../../../assets/img/defaultScreenshotVertical.jpg";
import defaultSSHorizontalWebp from "../../../assets/img/defaultScreenshotHorizontal.webp";
import defaultSSVerticalWebp from "../../../assets/img/defaultScreenshotVertical.webp";
import { assetUrl } from "../../config";
import WebP from "../global/WebP";
import { mobile } from "../../utilities/detection";
import ArrowRight from "../../../assets/svg/arrowRight.svg";

export default function GameScreenshots({ game, clickHandler }) {
  const renderScreenShots = () => {
    if (game.screenshots && game.screenshots.length > 0) {
      return game.screenshots.map((ss) => (
        <WebP secret={`${assetUrl}${ss}`} imgProps={{ alt: game.fullname, fetchPriority: "high" }} key={ss} />
      ));
    }

    const defaultVertical =
      (mobile && game.mobileOrientation && game.mobileOrientation === "portrait") || game.orientation === "portrait";

    return (
      <picture>
        <source srcSet={defaultVertical ? defaultSSVerticalWebp : defaultSSHorizontalWebp} type="image/webp" />
        <source srcSet={defaultVertical ? defaultSSVerticalJpg : defaultSSHorizontalJpg} type="image/jpeg" />

        <img src="" alt={game.fullname} />
      </picture>
    );
  };

  return (
    <div onClick={clickHandler} tabIndex={1} className="game-screenshots" data-testid="game-screenshots">
      {renderScreenShots()}
      <button type="button" className="playbutton button-flat-color orange dimensional">
        <ArrowRight />
      </button>
    </div>
  );
}
